<script lang="ts">
    import {addNew} from './services'
    import {currentUser} from './store'
    let title=""
    let content=""
    const add = async() =>{ 
        const {data,error} = await addNew($currentUser.id,title,content)
        if(error){
            alert(error.message)
        }else{
            title="";
            content="";
            alert("Success")
        }
    }
</script>

<h1>Add New Item</h1>
    Title: <br/>
    <input bind:value={title}><br/>
    Body: <br/>
    <textarea bind:value={content}/><br/>
    <button on:click="{()=>add()}">Add</button>
